/* istanbul ignore file */
export * from './lib/common-data-access-feature-config.module';
export * from './lib/services/feature-config-api.service';
export * from './lib/+state/feature-config.facade';
export * from './lib/initializer';
import * as FeatureConfigSelectors from './lib/+state/feature-config.selectors';
export { FeatureConfigSelectors };
export {
  FeatureConfigState,
  FeatureConfigPartialState,
  FEATURE_CONFIG_FEATURE_KEY,
} from './lib/+state/feature-config.reducers';
